var planMap = {
  id: 'id',
  name: 'name',
  price: 'price',
  billingPeriod: 'billingPeriod',
  noticePeriod: 'noticePeriod',
  noticePeriodUnit: 'noticePeriodUnit',
  initialPeriod: 'initialPeriod',
  initialPeriodUnit: 'initialPeriodUnit',
  entities: 'entities',
  userPermissions: 'userPermissions',
  walletPermissions: 'walletPermissions',
  termsURL: 'termsURL',
  planImageURL: 'planImageURL',
  isActive: 'isActive',
  priceVariationPlanIds: 'priceVariationPlanIds',
  priceVariationPlans: 'priceVariationPlans',
  dateDeactivated: 'dateDeactivated',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default planMap;